import { Button, Card, Col, Form, message, Row, Space } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { CheckOutlined } from '@ant-design/icons';

import { useQuery } from '../../../shared/hooks/use-query';
import { CommonQueryParamKey } from '../../../shared/models/common-query-params';
import { Feature } from '../../../shared/models/features';
import { JobUpsertForm, JobUpsertFormValues } from '../../components/job-upsert-form';
import { translationNamespace } from '../../constants/translation-resources';
import { convertFormValuesToJob } from '../../data/converters/job-converters';
import { useCreateJobMutation } from '../../data/mutations/job-mutations';
import { AppResourcePaths } from '../../../shared/constants/app-resources';

export const JobNewView: FC = () => {
  const { t } = useTranslation(translationNamespace);
  const { push: routerPush } = useHistory();
  const [form] = Form.useForm<JobUpsertFormValues>();
  const query = useQuery();
  const mutation = useCreateJobMutation();

  const parsedPrev = query.get(CommonQueryParamKey.PREV);
  const prevUrl = parsedPrev ?? AppResourcePaths.jobs;

  const submit = (values: JobUpsertFormValues) => {
    const newJob = convertFormValuesToJob(values);

    mutation.mutate(newJob, {
      onSuccess: () => {
        message.success(t('jobs.shared.createSuccessMessage'));
        routerPush(parsedPrev ?? `${AppResourcePaths.jobs}`);
      },
    });
  };

  const triggerSubmit = () => {
    form.submit();
  };

  return (
    <Row gutter={[16, 24]}>
      <Col span={24}>
        <Card title={t(`${Feature.SHARED}:details`)}>
          <JobUpsertForm isNew form={form} onSubmit={submit} />
        </Card>
      </Col>
      <Col>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            icon={<CheckOutlined />}
            loading={mutation.isLoading}
            onClick={triggerSubmit}
          >
            {t(`${Feature.SHARED}:create`)}
          </Button>
          <Link to={prevUrl}>
            <Button htmlType="button" size="large">
              {t(`${Feature.SHARED}:cancel`)}
            </Button>
          </Link>
        </Space>
      </Col>
    </Row>
  );
};
